import React, { useState } from 'react'
import { Button, Form, Input } from 'antd'
import { ModalConfirm } from '@/components'
import { sendMessagePost } from '@/utils/apiEndpoints'
import { useSelector } from 'react-redux'
import common from '@/utils/common'

export const SendMessage = ({
  user,
  showButton = false,
  isHostMessage,
  type = 'link',
  size = 'large',
  style = {},
  labelText = 'Message User',
  showLogin = () => { },
}) => {
  const { currentUser } = useSelector((state) => state.auth)
  const [loading, setLoading] = useState(false)
  const [open, setOpen] = useState(false)
  const formItems = () => (
    <Form.Item
      label={isHostMessage ? 'Have a question? Feel free to ask the host' : ''}
      name="message"
      rules={[{ required: true, message: 'Please enter a message' }]}
    >
      <Input.TextArea placeholder="Write your message here" rows={4} />
    </Form.Item>
  )
  const onSubmit = async (values) => {
    try {
      const payload = {
        toMemberId: user._id,
        message: values.message,
        messageType: 'text',
      }
      setLoading(true)
      const response = await sendMessagePost(payload)
      if (response.status === 'success')
        common.successToast('Your message has been successfully sent.')
      else {
        common.errorToast(
          'I apologize for the inconvenience. It seems that there was an error while sending your message. Please try again, ensuring that all necessary information is provided. If the issue persists, please contact the technical support team for further assistance.',
        )
      }
      setOpen(false)
    } catch (e) {
      if (e.response?.data?.result)
        common.errorToast(e.response.data.result.message)
      else
        common.errorToast(
          'I apologize for the inconvenience. It seems that there was an error while sending your message. Please try again, ensuring that all necessary information is provided. If the issue persists, please contact the technical support team for further assistance.',
        )
    } finally {
      setLoading(false)
    }
  }
  return showButton || currentUser._id !== user._id ? (
    <>
      <Button
        style={style}
        type={type}
        size={size}
        onClick={() => {
          if (currentUser._id) {
            setOpen(true)
          } else {
            showLogin(true)
          }
        }}
      >
        {labelText}
      </Button>
      <ModalConfirm
        visible={open}
        className='send-message-attendee-modal'
        okText="Send message"
        formItems={formItems}
        title={`Send message to ${user && user.firstName}`}
        onSubmit={onSubmit}
        onCancel={() => {
          setOpen(false)
        }}
        okButtonProps={{ loading: loading }}
      />
    </>
  ) : (
    ''
  )
}
